import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
export const Tooltip = ({ content, children, disabled = false }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [position, setPosition] = useState({ top: 0, left: 0 });
    const triggerRef = useRef(null);
    const tooltipRef = useRef(null);
    useEffect(() => {
        if (isVisible && triggerRef.current && tooltipRef.current) {
            const triggerRect = triggerRef.current.getBoundingClientRect();
            const tooltipRect = tooltipRef.current.getBoundingClientRect();
            // Calculate position (centered above the trigger)
            const left = triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2);
            const top = triggerRect.top - tooltipRect.height - 8; // 8px gap
            setPosition({
                left: Math.max(8, Math.min(left, window.innerWidth - tooltipRect.width - 8)),
                top: Math.max(8, top)
            });
        }
    }, [isVisible]);
    const handleMouseEnter = () => {
        if (!disabled) {
            setIsVisible(true);
        }
    };
    const handleMouseLeave = () => {
        setIsVisible(false);
    };
    const clonedChild = React.cloneElement(children, {
        ref: triggerRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
    });
    return (_jsxs(_Fragment, { children: [clonedChild, isVisible && !disabled && createPortal(_jsx("div", { ref: tooltipRef, className: "fixed z-[9999] px-2 py-1 bg-gray-900 dark:bg-gray-700 text-white text-xs rounded whitespace-nowrap pointer-events-none transition-opacity duration-200", style: {
                    top: `${position.top}px`,
                    left: `${position.left}px`,
                }, children: content }), document.body)] }));
};
